import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import Home from './app/pages/layout/Home';
import About from './app/pages/layout/About';
import NotFound from './app/pages/layout/NotFound';
import ErrorPage from './app/pages/layout/ErrorPage';

const router = createBrowserRouter([
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: '/',
    element: <App />,
  },
  
]);

export default router;